export class VendorsDto {
    vendorName: string;
    phoneNumber: string;
    email: string;
}